import { Button } from '@/components';
import { RadixDialog } from '@/components/RadixDialog';
import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import { usePopUpsContext } from '@/modules/pmt/context';
import type { FC } from 'react';
import { ButtonGroup } from './RequestLoginDialog.styles';

export const RequestLoginDialog: FC = () => {
  const { t, setShowPMTPopUp } = useGlobalState();
  const { showRequestLoginDialog, setShowRequestLoginDialog, setIsFromRequestLoginDialog } = usePopUpsContext();

  const handleShowOnboardingPopup = () => {
    setShowRequestLoginDialog(false);
    setIsFromRequestLoginDialog(true);
    setShowPMTPopUp(true);
  };

  const handleClose = () => {
    setShowRequestLoginDialog(false);
    setIsFromRequestLoginDialog(false);
  };

  return (
    <RadixDialog.WithGraphicWrapper open={showRequestLoginDialog} onOpenChange={handleClose}>
      <RadixDialog.Header closeable onClose={handleClose} />
      <RadixDialog.Content>
        <RadixDialog.MainText>{t(MasterTranslation.ShipmentSumGuestUserPopupMainText)}</RadixDialog.MainText>
        <ButtonGroup>
          <RadixDialog.Close asChild>
            <Button
              isPMTButton
              truncate={2}
              size={ButtonSize.Large}
              variant={ButtonVariant.Outlined}
              onClick={handleClose}
            >
              {t(MasterTranslation.Cancel)}
            </Button>
          </RadixDialog.Close>
          <RadixDialog.Close asChild>
            <Button isPMTButton truncate={2} size={ButtonSize.Large} onClick={handleShowOnboardingPopup}>
              {t(MasterTranslation.LoginPopupButton)}
            </Button>
          </RadixDialog.Close>
        </ButtonGroup>
      </RadixDialog.Content>
    </RadixDialog.WithGraphicWrapper>
  );
};
